<div class="list-page">
  <header class="page-header">
    <h1 class="page-header__title">Receivables</h1>
    <p class="page-header__subtitle">
      Payment status for your completed projects, from CREtelligent accounting.
      Request early payment on outstanding items, and review payments applied.
    </p>
  </header>

  <div class="empty-state" data-testid="receivables-coming-soon">
    <p class="empty-state__title">Coming soon</p>
    <p class="empty-state__text">
      Receivables will appear here once this feature is available.
    </p>
  </div>
</div>
